import {Action} from "redux";
import {IClientMessageRoomsActionCreator} from "../action/client_message_rooms_action";

interface IClientMessageRoomsDispatcher {
    startPollingMessageRooms(): void;

    stopPollingMessageRooms(): void;
}

class Dispatcher implements IClientMessageRoomsDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientMessageRoomsActionCreator) {

    }

    public startPollingMessageRooms = (): void => {
        this.dispatch(this.actionCreator.requestStartPollingMessageRoomsAction());
    }

    public stopPollingMessageRooms = (): void => {
        this.dispatch(this.actionCreator.requestStopPollingMessageRoomsAction());
    }

}

const createClientMessageRoomsDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientMessageRoomsActionCreator): IClientMessageRoomsDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientMessageRoomsDispatcher, createClientMessageRoomsDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_message_rooms_dispatcher.ts